import clsx from "clsx";
import { FORM_MODE } from "constant";
import React from "react";

type P_Props = {
  title: string;
  mode: FORM_MODE;
  type?: "text" | "crud";
  className?: string;
};

// hiển thị title của CRUD modal theo language
export const RenderCrudTitle: React.FC<P_Props> = (props) => {
  const classes = clsx({
    "crud-modal__label": !props.type || props.type === "crud",
    [props.className || ""]: true,
  });

  const renderTitle = () => {
    if (props.mode === FORM_MODE.VIEW) return `Chi tiết ${props.title}`;
    if (props.mode === FORM_MODE.CREATE) return `Tạo mới ${props.title}`;
    return `Chỉnh sửa ${props.title}`;
  };

  return <span className={classes}>{renderTitle()}</span>;
};
